import modus from './modus.js';
import ortundwege from './orteundwege.js';

export default{
    modus: modus,
    orteundwege: ortundwege
}


// WEBPACK FOOTER //
// ./src/store/modules/index.js